import { sendJsonRequest } from "./utils";
import { isEmail, validateRequirements } from "../utils/validations";

function extendSuccessfullResponse(response) {
    return {
        message: "Success! Look out for an email to confirm your subscription.", // should come from engine
        response,
    };
}

async function raiseAllErrors(errors) {
    for (const error of errors) {
        await Promise.reject({error});
    }

    return Promise.resolve();
}

export default function dispatchAddNewsletter(siteId, email, fields) {
    const errors = validateRequirements({email}, {
        email: {
            validation: isEmail,
            message: "Please enter a valid email address"
        }
    });
    if (errors.length > 0) {
        return raiseAllErrors(errors);
    }

    const payload = {
        email,
        fields: fields || {},
        site_id: siteId,
        // @NOTE: groups: [],
        // @NOTE: 'user_id': , we need to pass userId if user a logged in
    };

    return sendJsonRequest("/core/users/subscribe_site/", "POST", payload).then(
        extendSuccessfullResponse
    );
}
